import { useCallback } from "react";
import {
  useCherryMiniApp,
  useCherryEnvironment,
} from "@cherrydotfun/miniapp-sdk/react";
import { useSubscribeToJwtAuthWithFlag } from "@privy-io/react-auth";

export function CherryAuthBridge({ children }: { children: React.ReactNode }) {
  const { isEmbedded } = useCherryEnvironment({ strict: true });
  const { launchToken, isReady, error } = useCherryMiniApp();
  const getExternalJwt = useCallback(async () => {
    return launchToken ?? "";
  }, [launchToken]);

  useSubscribeToJwtAuthWithFlag({
    isAuthenticated: isEmbedded && isReady && !!launchToken,
    getExternalJwt,
    enabled: isEmbedded,
  });

  return <>{children}</>;
}
